import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import SubscriptionGuard from './components/SubscriptionGuard';
import HomePage from './pages/HomePage';
import RoleSelection from './pages/RoleSelection';
import ProfileSelection from './pages/ProfileSelection';
import ChildSetup from './pages/ChildSetup';
import ParentSetup from './pages/ParentSetup';
import ParentDashboard from './pages/ParentDashboard';
import TeacherSetup from './pages/TeacherSetup';
import TeacherDashboard from './pages/TeacherDashboard';
import PaymentPage from './pages/PaymentPage';
import SubscriptionManagement from './pages/SubscriptionManagement';
import LinkCodePage from './pages/LinkCodePage';
import AgeSelection from './pages/AgeSelection';
import PreschoolTopics from './pages/PreschoolTopics';
import SubjectSelection from './pages/SubjectSelection';
import GameFormatSelection from './pages/GameFormatSelection';
import QuizGame from './pages/games/QuizGame';
import PuzzleGame from './pages/games/PuzzleGame';
import StoryGame from './pages/games/StoryGame';
import MemoryGame from './pages/games/MemoryGame';
import ProfileDashboard from './pages/ProfileDashboard';
import ResultScreen from './pages/ResultScreen';
import RewardsPage from './pages/RewardsPage';
import KidsBooksPage from './pages/KidsBooksPage';
import KidsVideosPage from './pages/KidsVideosPage';
import BadgesPage from './pages/BadgesPage';
// Legal Pages
import TermsOfService from './pages/legal/TermsOfService';
import ChildrensPrivacy from './pages/legal/ChildrensPrivacy';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import AffiliateTerms from './pages/legal/AffiliateTerms';
// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminQuizzes from './pages/admin/AdminQuizzes';
import AdminMemory from './pages/admin/AdminMemory';
import AdminStories from './pages/admin/AdminStories';
import { GameProvider } from './context/GameContext';
import { RewardsProvider } from './context/RewardsContext';
import { RewardAnimation, AchievementPopup } from './components/RewardsWidgets';
import './App.css';

function App() {
  return (
    <GameProvider>
      <RewardsProvider>
        <div className="App">
          <BrowserRouter>
            <RewardAnimation />
            <AchievementPopup />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/role-selection" element={<RoleSelection />} />
              <Route path="/profile-selection" element={<ProfileSelection />} />
              <Route path="/child-setup" element={<ChildSetup />} />
              <Route path="/parent-setup" element={<ParentSetup />} />
              <Route path="/parent-dashboard" element={<ParentDashboard />} />
              <Route path="/teacher-setup" element={<TeacherSetup />} />
              <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/subscription" element={<SubscriptionManagement />} />
              <Route path="/link-code" element={<LinkCodePage />} />
              <Route path="/age-selection" element={<SubscriptionGuard><AgeSelection /></SubscriptionGuard>} />
              <Route path="/preschool-topics" element={<SubscriptionGuard><PreschoolTopics /></SubscriptionGuard>} />
              <Route path="/subject-selection" element={<SubscriptionGuard><SubjectSelection /></SubscriptionGuard>} />
              <Route path="/game-format" element={<SubscriptionGuard><GameFormatSelection /></SubscriptionGuard>} />
              <Route path="/game/quiz" element={<SubscriptionGuard><QuizGame /></SubscriptionGuard>} />
              <Route path="/game/puzzle" element={<SubscriptionGuard><PuzzleGame /></SubscriptionGuard>} />
              <Route path="/game/story" element={<SubscriptionGuard><StoryGame /></SubscriptionGuard>} />
              <Route path="/game/memory" element={<SubscriptionGuard><MemoryGame /></SubscriptionGuard>} />
              <Route path="/profile" element={<SubscriptionGuard><ProfileDashboard /></SubscriptionGuard>} />
              <Route path="/result" element={<SubscriptionGuard><ResultScreen /></SubscriptionGuard>} />
              <Route path="/rewards" element={<SubscriptionGuard><RewardsPage /></SubscriptionGuard>} />
              <Route path="/badges" element={<SubscriptionGuard><BadgesPage /></SubscriptionGuard>} />
              <Route path="/kids-books" element={<SubscriptionGuard><KidsBooksPage /></SubscriptionGuard>} />
              <Route path="/kids-videos" element={<SubscriptionGuard><KidsVideosPage /></SubscriptionGuard>} />
              {/* Legal Pages */}
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/childrens-privacy" element={<ChildrensPrivacy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/affiliate-terms" element={<AffiliateTerms />} />
              {/* Admin Pages */}
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/quizzes" element={<AdminQuizzes />} />
              <Route path="/admin/memory" element={<AdminMemory />} />
              <Route path="/admin/stories" element={<AdminStories />} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </div>
      </RewardsProvider>
    </GameProvider>
  );
}

export default App;
